export default "__VITE_ASSET__x_TIczox__"